import * as Sentry from "@sentry/react";

let isSentryInitialized = false; // Prevent multiple inits

export const initializeSentry = async (
  dsn: string,
  environmentUrl: string,
  version?: string
) => {
  if (!dsn) {
    console.warn("[Sentry] DSN not provided. Skipping initialization.");
    return;
  }

  if (!environmentUrl) {
    console.warn(
      "[Sentry] Host environment not provided. Skipping initialization."
    );
    return;
  }

  if (isSentryInitialized) {
    console.log("[Sentry] Already initialized. Skipping re-initialization.");
    return;
  }

  isSentryInitialized = true; // Mark as initialized

  Sentry.init({
    dsn,
    environment: environmentUrl.substring(0, 64),
    release: version,
    // Error monitoring only. Performance tracing and Session Replay are the
    // paid-quota-heavy features, so they are left off (no integrations, sample
    // rates at 0) to keep Sentry ingest as close to $0 as possible. This also
    // tree-shakes the tracing/replay bundles out of the build.
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    // Drop known third-party / browser-extension noise: password managers and
    // similar extensions dispatch synthetic keydown events (missing the native
    // getModifierState method) into the Monaco editor on the workflow page.
    // This is not an app bug and does not affect functionality — filter it out.
    ignoreErrors: [/getModifierState is not a function/],
  });

  console.log(`[Sentry] Initialized with Version: ${version}`);
};
